module.exports = __webpack_public_path__ + "img/bing.81dae931.png";